<template>
    <form @submit.prevent="submitForm" method="POST" class="mw-360 mx-auto" v-if="!sign">

        <div class="alert alert-success" v-if="success_login.length">
            <div v-if="time > 0" class="my-md">
                <h3 class="fw-bold text-center">Check your inbox!</h3>
                <p class="text-center my-md">{{ success_login }}</p>

                <div class="d-flex align-center gap-md">
                    <div class="w-50 text-right">
                        <img :src="`${images_url}/login/mail.png`" class="d-inline-block" style="height:75px" loading="lazy" />
                    </div>
                    <div class="w-50 ml-xs text-left">
                        <h1>
                            <strong>{{ time }}</strong> <span class="text-extra">sec</span>
                        </h1>
                    </div>
                </div>
                <div class="text-center mt-sm">until the next email can be sent</div>
            </div>
            <div class="text-center mb-md" v-else>
                <img :src="`${images_url}/login/mail.png`" class="d-inline-block" style="height:75px" loading="lazy" />
            </div>
        </div>
        <template v-else>
            <h3 class="fw-bold text-center">Welcome back!</h3>
            <p class="text-center my-md">Enter your email address, and we'll send you a link to log in.</p>
            <div class="form-field width-100">
                <input
                    v-model="email"
                    name="email"
                    type="email"
                    id="email"
                    autocomplete="email"
                    placeholder=""
                    required
                    :class="emailClasses"
                />
                <label for="email">Your email<sup>*</sup></label>
                <div class="alert--input" v-if="error_login.length">{{ error_login }}</div>
            </div>

            <button
                :class="`btn btn--primary btn--full ${isLoading ? 'loading' : ''}`"
                :disabled="isLoading"
                type="submit"
            >Send link</button>
            <div class="text-center text-small my-md">
                New to Sellvia Mall?
                <a @click="sign = true" class="d-inline-block cursor-pointer pl-sm">
                    Sign up <i class="icon-arrow_right"></i>
                </a>
            </div>
        </template>
    </form>

    <form @submit.prevent="submitFormSign" method="POST" class="mw-360 mx-auto" v-else>
        <div class="alert alert-success" v-if="success_register.length">
            <h2 class="fw-bold text-center">
                Check your inbox!
            </h2>
            <h3 class="mw-500 text-large mt-sm text-center">{{ success_register }}</h3>
            <div class="text-center mt-ml">
                <img :src="`${images_url}/login/mail.png`" class="d-inline-block" style="height:75px" loading="lazy" />
            </div>
        </div>
        <template v-else>
            <h3 class="fw-bold text-center">Welcome to Sellvia Mall!</h3>
            <p class="text-center my-md">
                Let's create your free account. Fill in the details below to get access
                to our exclusive bonuses for members only.
            </p>
            <div class="form-field width-100">
                <input
                    v-model="user.email"
                    name="email"
                    type="email"
                    id="email"
                    autocomplete="email"
                    placeholder=""
                    required
                    @blur="validateEmail"
                    :class="emailClasses"
                />
                <label for="email">Your Email<sup>*</sup></label>
                <div class="alert--input" v-if="error_email.length">{{ error_email }}</div>
            </div>

            <div class="form-group-fields">
                <div class="form-field flex-1">
                    <input
                        v-model="user.first_name"
                        name="first_name"
                        type="text"
                        id="first_name"
                        autocomplete="given-name"
                        placeholder=""
                    />
                    <label for="first_name">First Name</label>
                </div>
                <div class="form-field flex-1">
                    <input
                        v-model="user.last_name"
                        name="last_name"
                        type="text"
                        id="last_name"
                        autocomplete="family-name"
                        placeholder=""
                    />
                    <label for="first_name">Last Name</label>
                </div>
            </div>

            <div class="form-field">
                <CustomSelect
                    v-model="user.code"
                    :options="codes"
                    placeholder="Select your country code"
                    label="Country code"
                    :require="true"
                    @update:modelValue="updateMask"
                />
            </div>
            <div class="form-field">
                <input
                    v-model="user.phone_number"
                    name="fn_num_2"
                    type="tel"
                    id="fn_num_2"
                    @input="handleInput"
                    @keydown="handleKeydown"
                    @blur="handleBlur"
                    :placeholder="activeMask"
                    required
                    :class="[emptyField( user.phone_number ), 'on_top']"
                />
                <label for="fn_num_2">Your phone number<sup>*</sup></label>
            </div>

            <div class="text-center text-red my-md" v-if="error_register.length">
                {{ error_register }}
            </div>

            <button
                :class="`btn btn--primary btn--full ${isLoading ? 'loading' : ''}`"
                :disabled="isLoading"
                type="submit"
            >Sign up</button>
        </template>
        <div class="text-center text-small my-md">
            Already registered?
            <a @click="sign = false" class="d-inline-block cursor-pointer">
                Log in <i class="icon-arrow_right"></i>
            </a>
        </div>
    </form>
</template>

<script>
import { defineComponent } from 'vue'
import { toRaw } from 'vue';
import CustomSelect from "@/Goya/components/Common/CustomSelect.vue";
export default defineComponent({
    name: "login",
    components: {CustomSelect},
    data() {
        return {
            isLoading: false, // защита от множественных запросов
            images_url: '/templates/Goya/assets/images',
            email: '',
            isEmailValid: false,
            error_login: '', // ошибка при попытке авторизации
            error_email: '',
            error_register: '',
            success_login: '', // успешно при авторизации
            success_register: '',
            time : 0, // таймер обратного отсчёта сколько секунд осталось до следующей отправки
            timerId: null,
            sign: false,
            stats: window.stats || [],
            codes: [],
            user: {
                email: '',
                first_name: '',
                last_name: '',
                phone_number: '',
                code: 'US'
            },
            activeMask: '(###) ###-####',
            masks: {}
        }
    },
    computed: {
        emailClasses() {
            return {
                'filled': this.isEmailValid && this.email,
                'error': !this.isEmailValid && this.email,
                'error_send': this.error_login.length,
                'empty': ! this.isEmailValid && this.email.length === 0,
            };
        }
    },
    mounted() {
        this.loadCountries()
    },
    methods: {
        emptyField( field ) {
            const v = field.trim();
            return v !== '' ? 'filled' : 'empty';
        },

        validateEmail() {
            // Регулярка для валидации email (рекомендуемый вариант)
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            if (!this.user.email) {
                this.isEmailValid = false;
                this.error_email = 'Email required';
            } else if (!regex.test(this.user.email)) {
                this.isEmailValid = false;
                this.error_email = 'Incorrect email';
            } else {
                this.isEmailValid = true;
                this.error_email = '';
            }
        },

        isValidEmail( email ) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test( email ) || ! email;
        },

        /**
         * Отправка формы авторизации
         */
        async submitForm() {

            if( this.isLoading )
                return;

            if( ! this.isValidEmail( this.email ) ) {
                this.error_login = 'The email field is filled in incorrectly.';
                return;
            }

            this.isLoading     = true
            this.error_login   = '';
            this.success_login = '';

            try {
                const response = await this.$http.post('/auth/loginEmail', { email: this.email })

                const { status, code, data } = response.data;

                if( !!data?.status && data.status === 'error' ) {
                    this.error_login = data.data.message
                    return;
                }

                if( !!data?.time ) {
                    this.success_login = data.message
                    this.time    = data.time
                    this.timerId = setInterval(() => {
                        if( this.time > 0 ) {
                            this.time -= 1;
                        }
                    }, 1000 )

                    setTimeout(() => {
                        this.success_login = '';
                        clearInterval( this.timerId )
                    }, this.time * 1000);
                } else {
                    this.error_login = data.message
                }
            } catch (err) {
                console.error('error: ', err)
                // показываем ошибку на странице
            } finally {
                this.isLoading = false
            }
        },

        /**
         * Отправка формы регистрации
         * @returns {Promise<void>}
         */
        async submitFormSign() {
            if( this.isLoading )
                return;

            if( ! this.isValidEmail( this.user.email ) ) {
                this.error_register = 'The email field is filled in incorrectly.';
                return;
            }

            this.isLoading          = true
            this.error_register     = '';
            this.success_register   = '';

            let obj = structuredClone( toRaw( this.user ) );
            obj.phone_number = this.getPhoneNumber();

            const trackerRaw = localStorage.getItem('utm_tracker'); // получаем трекер
            if( trackerRaw ) {
                try {
                    const tracker = JSON.parse( trackerRaw );
                    if( tracker?.source && tracker.source.trim() !== '' ) {
                        obj.utm_source      = tracker.source;
                        obj.utm_medium      = tracker.medium || 'cpc';
                        obj.utm_campaign    = tracker.campaign || 'none';
                        obj.utm_content     = tracker.content || '';
                        obj.utm_term        = tracker.term || '';
                        obj.utm_captured_at = tracker.captured_at || Date.now();
                    }
                } catch (e) {}
            }

            try {
                const response = await this.$http.post('/auth/registerEmail', obj)

                const { status, code, data } = response.data;

                if( status === 'error' ) {
                    this.error_register = data.message
                    return;
                }

                if( !!data?.status && data.status === 'error' ) {
                    this.error_register = data.message
                    return;
                }

                if( !!data?.message ) {
                    this.success_register = data.message

                    // отправка события в Google Tag Manager
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'lead'
                    });
                } else {
                    this.error_register = 'Internal error. Please try again later'
                }
            } catch (err) {
                console.error('error: ', err)
                // показываем ошибку на странице
            } finally {
                this.isLoading = false
            }
        },

        /**
         * Грузим страны и коды телефонов
         * @returns {Promise<void>}
         */
        async loadCountries() {
            this.loading = true;
            try {
                const response = await this.$http.post('/ref/countriesList')
                if( response.data.status === 'error' ) {
                    this.error = this.error.message
                    return;
                }

                const countries = response.data.data.countries

                let masks = {};
                let codes = [];

                Object.keys(countries).forEach((iso) => {
                    let country = countries[iso];
                    if( country?.mask && country?.cc && country?.name ) {

                        masks[ iso ] = country.mask.replace(country.cc, '')
                            .replace(/0/g, '#')
                            .trim();

                        codes.push({
                            value: iso,
                            label: `${country.name} ${country.cc}`,
                            code: country.cc,
                        });
                    }
                })

                // Сортируем: сначала страну по умолчанию, потом остальные по алфавиту
                codes.sort((a, b) => {
                    if (a.code === this.user.code) return -1;
                    if (b.code === this.user.code) return 1;
                    return a.label.localeCompare(b.label);
                });

                this.codes = codes;
                this.masks = masks;

            } catch (e) {
                console.error('error: ', e)
            } finally {
                this.loading = false;
            }
        },

        getPhoneNumber() {

            let c = this.masks[ this.user.code ];
            if( c ) {
                const phone = this.user.phone_number.replace(/\D/g, ""); // Только цифры
                if( phone.length ) {

                    c = c.replace(/\D/g, ""); // Только цифры

                    return `+${c}${phone}`;
                }
            }

            return '';
        },

        updateMask( value, isInitial = false ) {

            const mask = this.masks[ this.user.code ]
            if( ! mask || this.activeMask === mask ) return;

            this.activeMask = this.masks[ this.user.code ];

            if( ! isInitial ) {
                this.user.phone_number = '';
            }
        },

        handleKeydown(event) {
            if (event.key === 'Backspace') {
                const input = event.target;
                const start = input.selectionStart;
                const end = input.selectionEnd;

                // Если выделенного текста нет — обрабатываем умное удаление
                if (start === end && start > 0) {
                    const charToDelete = input.value[start - 1];

                    // Если перед курсором не цифра (дефис, скобка, пробел)
                    if (/\D/.test(charToDelete)) {
                        event.preventDefault(); // Останавливаем стандартный Backspace

                        // Ищем позицию последней цифры перед курсором
                        let lastDigitIndex = -1;
                        for (let i = start - 1; i >= 0; i--) {
                            if (/\d/.test(input.value[i])) {
                                lastDigitIndex = i;
                                break;
                            }
                        }

                        if (lastDigitIndex !== -1) {
                            // Удаляем эту цифру из v-model
                            const val = input.value;

                            // Обновляем значение и ставим курсор
                            this.user.phone_number = val.substring(0, lastDigitIndex) + val.substring(start);

                            this.$nextTick(() => {
                                // Ставим курсор туда, где была удалена цифра
                                input.setSelectionRange(lastDigitIndex, lastDigitIndex);
                                // Вызываем handleInput вручную, чтобы маска пересчиталась
                                this.handleInput({ target: input });
                            });
                        }
                    }
                }
            }
        },

        handleInput(event) {
            const input = event.target;
            const oldSelectionStart = input.selectionStart;
            const oldLength = input.value.length;

            const rawValue = input.value.replace(/\D/g, ""); // Только цифры

            if( rawValue.length === 0 ) {
                this.user.phone_number = ''
                return;
            }

            let formatted = "";
            let digitIndex = 0;

            // Проходим по маске и подставляем цифры
            for (let i = 0; i < this.activeMask.length; i++) {
                const maskChar = this.activeMask[i];

                if (maskChar === "#") {
                    // Если в маске решетка — берем следующую цифру из ввода
                    if (digitIndex < rawValue.length) {
                        formatted += rawValue[digitIndex];
                        digitIndex++;
                    } else {
                        break; // Цифры кончились
                    }
                } else {
                    formatted += maskChar;
                    if (digitIndex < rawValue.length && maskChar === rawValue[digitIndex]) {
                        digitIndex++;
                    }
                }
            }

            this.user.phone_number = formatted;

            // Возвращаем курсор на место, иначе он прыгнет в конец
            this.$nextTick(() => {
                // Вычисляем, насколько изменилась длина строки
                const lengthDiff = formatted.length - oldLength;
                let newPosition = oldSelectionStart + lengthDiff;

                // Магия: если курсор уперся в статичный символ маски (пробел, скобку),
                // двигаем его вперед до ближайшей "решетки" или конца строки
                while (
                    newPosition < formatted.length &&
                    this.activeMask[newPosition] !== "#" &&
                    formatted[newPosition] !== rawValue[rawValue.length - 1] // проверка на последнюю введенную цифру
                    ) {
                    newPosition++;
                }

                input.setSelectionRange(newPosition, newPosition);
            });
        },

        handleBlur() {
            const currentVal = this.user.phone_number;
            const currentDigits = currentVal.replace(/\D/g, "");
            const maskDigits = this.activeMask.replace(/[^0-9]/g, "");
            if (currentDigits === maskDigits || currentDigits.length === 0) {
                this.user.phone_number = ""; // Очищаем в ноль
            }
        }
    }
});
</script>

<style scoped>

</style>